import React, { useState } from 'react'
import { Button, Stack, SimpleModal, Text, FormControl, Textarea, Alert } from '@/components/lib'
import api from '../../api'

export default function DatabaseLocker ({ trial, isLocking, trigger, onComplete }) {
  const [open, setOpen] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')
  const [justification, setJustification] = useState('')

  const toggleLock = () => {
    setError('')
    setLoading(true)
    api.trials.update(trial?._id, { isDatabaseLocked: !trial.isDatabaseLocked, databaseLockJustification: justification }, newTrial => {
      onComplete(newTrial)
      setLoading(false)
      setOpen(false)
    }, err => {
      setError(err.message)
      setLoading(false)
    })
  }

  return (
    <>
      {trigger
        ? React.cloneElement(trigger, { onClick: () => setOpen(true) })
        : <Button onClick={() => setOpen(true)}>{isLocking ? 'Lock database' : 'Unlock database'}</Button>}
      <SimpleModal
        isOpen={open} onClose={() => setOpen(false)} modalProps={{ size: 'xl' }}
        header={isLocking ? 'Lock database' : 'Unlock database'}
        body={
          <Stack gap={5}>
            <Text>{isLocking ? 'When the database is locked, no new data can be created or edited within the trial (responses, participants, queries, notes, etc.). Tasks, files, and messages will continue to work normally.' : 'Unlocking the database will enable the creation and editing of data within the trial.'}</Text>
            <FormControl label='Justification' isRequired helperText='A brief justification or sign-off note for this action is required.'>
              <Textarea value={justification} onChange={e => setJustification(e.target.value)} />
            </FormControl>

            <Alert variant='left-accent'>Please note that trial administrators will be notified of this change.</Alert>
          </Stack>
}
        footer={
          <>
            {error && <Alert variant='left-accent' status='error'>{error}</Alert>}
            <Button onClick={e => setOpen(false)}>Cancel</Button>
            <Button isLoading={loading} colorPalette='primary' onClick={toggleLock}>{isLocking ? 'Lock database' : 'Unlock database'}</Button>
          </>
}
      />
    </>
  )
}
